import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, numberAttribute } from '@angular/core';
import { DsTooltipDirectiveModule } from '@bmw-ds/components';

import { useI18n } from '../../../../i18n/services/i18n.service';
import { NextBestVehicle } from '../../../../insights/model/insights';

@Component({
  selector: 'cdf-next-best-vehicle',
  imports: [DsTooltipDirectiveModule],
  host: {
    '[class.image-only]': 'imageOnly()',
    '[class.image-small]': 'imageSmall()',
  },
  template: `
    @for (vehicle of displayedVehicles(); track vehicle.modelCode) {
      <div class="vehicle-image">
        @if (vehicle.imageUrl) {
          <img
            [alt]="vehicle.modelCode"
            [ds-tooltip]="vehicle.modelCode"
            [dsTooltipConfig]="{ origin: 'bottom' }"
            [src]="vehicle.imageUrl"
            (error)="onImageError($event)"
          />
        }
        <span>{{ vehicle.modelCode }}</span>
      </div>
      <div class="vehicle-model">
        <h4>{{ i18n('customerInsights.nextBestVehicleModel') }}</h4>
        <span>{{ vehicle.modelCode }}</span>
      </div>
    }
    @if (hiddenVehicles() > 0) {
      <div class="hidden-vehicles">+ {{ hiddenVehicles() }}</div>
    }
  `,
  styleUrl: './next-best-vehicle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NextBestVehicleComponent {
  protected readonly i18n = useI18n();

  readonly vehicles = input.required<NextBestVehicle[] | undefined>();
  readonly imageOnly = input(false, { transform: booleanAttribute });
  readonly imageSmall = input(false, { transform: booleanAttribute });
  readonly maxVehicles = input(undefined, { transform: numberAttribute });

  onImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.classList.add('image-error');
  }

  protected readonly displayedVehicles = computed(() => this.vehicles()?.slice(0, this.maxVehicles()));
  protected readonly hiddenVehicles = computed(() =>
    Math.max((this.vehicles()?.length ?? 0) - (this.maxVehicles() ?? Infinity), 0),
  );
}
